// src/features/auth/authSlice.js
import { createSlice } from '@reduxjs/toolkit';
import {  logout,adminLogin } from './authActions';

const initialState = {
    data: null,
    userData: null,
    loading: false,
    error: null,
};

const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        resetError(state) {
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        builder
           

            .addCase(adminLogin.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(adminLogin.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(adminLogin.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })

    
            .addCase(logout.fulfilled, (state) => {
                state.data = null;
            });

            
    },
});

export const { resetError } = authSlice.actions;

export default authSlice.reducer;
